import classNames from 'classnames'
import { MyBtn } from '~/components/ui/MyBtn'
import {
  CrActivityBuyStatus,
  CrowdfundingActivityStatusEnum,
} from '~/graphqls/types'

export default function BuyBtn({
  status,
  buyStatus,
  onClick,
}: {
  status: CrowdfundingActivityStatusEnum
  buyStatus: CrActivityBuyStatus
  onClick: () => void
}) {
  let text = ''
  let disabled = true

  switch (status) {
    case CrowdfundingActivityStatusEnum.UN_START:
      text = '即将开售'
      disabled = true
      break
    case CrowdfundingActivityStatusEnum.START:
      text = '购买支持'
      disabled = false
      break
    case CrowdfundingActivityStatusEnum.PUBLIC:
      text = '立即购买'
      disabled = false
      break
    case CrowdfundingActivityStatusEnum.FAILED:
    case CrowdfundingActivityStatusEnum.FAILED_REFUNDED:
      text = '预售失败'
      disabled = true
      break
    case CrowdfundingActivityStatusEnum.SUCCESS:
      text = '作品发放中'
      disabled = true
      break
    case CrowdfundingActivityStatusEnum.END:
      text = '已售罄'
      disabled = true
      break
    case CrowdfundingActivityStatusEnum.PRESALE_END:
      text = '已售罄'
      disabled = true
      break
  }

  // 购买限制
  if (
    status === CrowdfundingActivityStatusEnum.START ||
    status === CrowdfundingActivityStatusEnum.PUBLIC
  ) {
    if (buyStatus === CrActivityBuyStatus.LIMIT) {
      text = '已购买'
      disabled = true
    } else if (buyStatus === CrActivityBuyStatus.CAN_NOT_BOUGHT) {
      text = '暂无购买权益'
      disabled = true
    }
  }

  const handleClick = () => {
    if (disabled) return

    onClick()
  }

  return (
    <MyBtn
      type="primary"
      className={classNames('w-full', {
        '!cursor-not-allowed !opacity-70': disabled,
      })}
      size="large"
      onClick={handleClick}
    >
      {text}
    </MyBtn>
  )
}
